import registry from "frontend/api/registry"

export default (name, func) => registry[name]().then(func)
